import { View, Log, Utils } from '../vendor/kerneljs';
import { Forms } from '../components/forms';
import { default as CustomSelect } from '../components/custom-select';
import { default as SearchAhead } from '../components/search-ahead';
import { default as ParkingTimePicker } from '../components/parking-time-picker';
import { default as MapsPeopleMap } from '../components/maps-people-map';
import { default as Overlay } from '../components/overlay';

//@ Param
// content: [String / Html] Content to be shown in modalbox
// header: [String] Header caption
// showHeader: [bool] show or hide the header
// showFooter: [bool] show or hide the footer
// render: [function] public function that opens the modalbox
// remove: [function] public function that closes the modalbox
// onOk: [function] cb function triggered on ok click
// onCancel: [function] cb function triggered on cancel click
// onClose: [function] cb function triggered on close click
//@ end

const ModalBox = View.extend({

	viewName: 'ModalBox',

	className: 'modal',

	events: {
		'click .js--close-modal': 'onClose'
	},

	initialize: function() {
		let defaultTemplateContent = Utils.find('#modalTemplate')[0].innerHTML;
		this.el = Utils.createEl('div.'+this.className+' '+this.settings.cssClasses);
		this.el.innerHTML = defaultTemplateContent;
		this.find('.modal__content').innerHTML = this.settings.content;
		this.overlay = new Overlay({ isFixed: true, fixBody: this.settings.fixBody });
		this.eventEmitter.on('overlay:clicked', this.close.bind(this));
	},

	render: function(e) {
		this.overlay.render();
		this.overlay.append(this.el);
		this.eventEmitter.emit('modalbox:rendered', this, e);

		window.dispatchEvent(new Event('accordion:init'));

		Utils.each(Utils.find('.js--has-search-ahead'), function(elem) {
			new SearchAhead( {el: elem} );
		});
		Utils.each(Utils.find('.js--parking-time-picker'), function(elem) {
			new ParkingTimePicker( {el: elem} );
		});
		Utils.each( Utils.find('.form'), function(elem) {
			try {
			new Forms( {el: elem} );
		}
		catch(err) {
		  console.log(err.message);
		}
		});
		Utils.each(Utils.find('.js--custom-select'), function(elem) {
			if ( !Utils.hasClass(elem, 'is-custom') ) new CustomSelect( {el: elem} );
		});

		window.dispatchEvent(new Event('modal:init'));


		function mapsLoadHandler() {
			window.googleMapsLoaded = true;
			Utils.each(Utils.find('.js--maps-people-map'), function(elem) {
				new MapsPeopleMap( {el: elem} );
			});
		}
		if ( window["google"] && !window.googleMapsLoaded ) {
			window.google.maps.event.addDomListener(window, 'load', mapsLoadHandler);
		}
		else {
			mapsLoadHandler();
		}

		this.frame = this.find('iframe');
		this.modalMiddle = this.find('.modal__middle__inner');

		if ( this.frame instanceof HTMLElement ) {
			this.frame.addEventListener('load', this.iframeLoadedHandler.bind(this));
		}

		let modalEvent = new CustomEvent('modal:render', { detail: {modal:this} });
		window.dispatchEvent(modalEvent);
	},

	iframeLoadedHandler:function(event) {
		this.resizeIframeContent();

		Utils.on(window, 'resize', this.resizeIframeContent.bind(this));

		this.frame.removeEventListener('load', this.iframeLoadedHandler);
	},

	resizeIframeContent:function(){
		clearTimeout(this.resizeTimeout);
		this.resizeTimeout = setTimeout( function(){
			if ( this.frame.contentWindow ) {
				let dims = {
					w:this.modalMiddle.offsetWidth,
					h:this.frame.contentWindow.document.body.offsetHeight
				};
				this.frame.setAttribute('height', dims.h);
				this.frame.setAttribute('width', dims.w);
			}
		}.bind(this), 100)
	},

	onClose: function(e) {
		Log.fn('ModalBox | onClose');
		e.stopPropagation();
		this.eventEmitter.emit('modal:close');
		this.close();
	},

	close:function() {
		this.remove();
	}

});

(function(){
	function init() {
		Utils.each( Utils.find('.js--open-modal'), function(elem) {
			if ( !Utils.hasClass(elem, 'is-bound') ) {

				Utils.addClass(elem, 'is-bound');

				let clickHandler = function() {
					let template = this.getAttribute('data-template') ? Utils.find('#'+this.getAttribute('data-template'))[0] : null;
					if (!template)
						return false
					let content = template.innerHTML;
					let cssClasses =  template.getAttribute('data-classes') || ''
					cssClasses += this.getAttribute('data-classes') ? ' ' + this.getAttribute('data-classes') : '';
					
					let fixBody = this.getAttribute('data-fixbody') ? this.getAttribute('data-fixbody') === "true" : false;

					let instantiationFail = false;
					if ( typeof template === 'undefined' ) {
						Log.er("ModalBox | no template");
						instantiationFail = true;
					}
					if ( typeof content === 'undefined' ) {
						Log.er("ModalBox | no content");
						instantiationFail = true;
					}
					if ( typeof fixBody === 'undefined' ) {
						Log.er("ModalBox | no fixBody");
						instantiationFail = true;
					}
					if ( typeof cssClasses === 'undefined' ) {
						Log.er("ModalBox | no cssClasses");
						instantiationFail = true;
					}
					if ( instantiationFail ) return false;

					else {
						let modal = new ModalBox({ content: content, cssClasses:cssClasses, fixBody:fixBody});
						modal.render();
					}
				}

				Utils.on(elem,'click', clickHandler);
				let triggerDelay = elem.getAttribute('data-triggerdelay');
				if ( triggerDelay ) {
					setTimeout(function() {
						let event = new Event('click');
						elem.dispatchEvent(event);
					}, triggerDelay);
				}
			}

		});
	}

	init();
	window.addEventListener('modal:init', init);
})();

export default ModalBox;